import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import moment from 'moment'
import * as RE from 'helpers/ramda-ext'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getCities,
  getDaysSinceStartSale,
  getHasVisibleDurationPicker,
  getOperationCode,
  getPriceUnit,
  getProductSourceKey,
  getProductTitle,
  getSaleStartTime,
  getSubUniverseNameExcludingAllProducts,
  getUniverseNameExcludingAllProducts
} from 'store/selectors'
import { getCityName } from 'domain/pricerDepartureCity'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state, action) => { // (eventName: string, state: State, action: ConfiguratorSelectionChangeAction):
  const { payload: { selection } } = action

  const MPEvent = {
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Interaction Type': 'Click',
    'Operation Code': getOperationCode(state),
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state),
    'Sale Start Time': getSaleStartTime(state),
    'Under Universe': getSubUniverseNameExcludingAllProducts(state),
    'Unit': getPriceUnit(state),
    'Universe': getUniverseNameExcludingAllProducts(state)
  }

  if (selection.departureCity) {
    const cities = getCities(state)
    MPEvent['Departure City'] = getCityName(cities, selection.departureCity).label
  } else if (RE.isNotNil(selection.nights)) {
    MPEvent['Number of Nights'] = selection.nights
  } else if (selection.checkin) {
    MPEvent['Search Date'] = moment(selection.checkin).format('YYYY-MM-DDTHH:mm:ss')
  }

  return MPEvent
}

// type GetEventName = (any, State) => ?string // (ConfiguratorSelectionChangeAction, State)
const getEventName = ({ payload: { selection } }, state) => {
  const hasVisibleDurationPicker = getHasVisibleDurationPicker(state)

  if (selection.departureCity) {
    return 'Click Select Departure City'
  } else if (!hasVisibleDurationPicker && selection.checkin) {
    return 'Click Select Length and Date'
  } else if (selection.checkin) {
    return 'Click Select Departure Date'
  } else if (RE.isNotNil(selection.nights)) {
    return 'Click Select Length of Stay'
  }
}

const clickConfiguratorSelectionChangeEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.configurator.CONFIGURATOR_SELECTION_CHANGE),
  tap(action => {
    if (!action.payload.isAutoSelect) {
      const state = state$.value
      const eventName = getEventName(action, state)

      if (eventName) {
        track(eventName, mapStateToMPEvent(eventName, state, action), { debug: !__PRODUCTION__ })
      }
    }
  }),
  ignoreElements()
)

export default clickConfiguratorSelectionChangeEpic
